<template>
    <div>
        <success-notification
            id="success_notification"
            :message="notificationMessage"
            :showNotification="showNotification.success"
        ></success-notification>

        <info-notification
            id="info_notification"
            :message="notificationMessage"
            :showNotification="showNotification.info"
        ></info-notification>

        <error-notification
            id="error_notification"
            :message="notificationMessage"
            :showNotification="showNotification.error"
        ></error-notification>
    </div>
</template>
<script>
import SuccessNotification from '@/components/notifications/SuccessNotification.vue';
import InfoNotification from '@/components/notifications/InfoNotification.vue';
import ErrorNotification from '@/components/notifications/ErrorNotification.vue';
export default {
    components: {
        SuccessNotification,
        InfoNotification,
        ErrorNotification,
    },
    created() {
        // Add listener
        // const el = document.getElementsByTagName("body");
        // Load flash messages
        window.flashMessage = function (payload) {
            document.dispatchEvent(
                new CustomEvent('flash-message', {
                    detail: payload,
                })
            );
        };

        document.addEventListener(
            'flash-message',
            (event) => {
                this.showMessage(event);
            },
            false
        );
        // On event show notification
    },
    destroyed() {},
    data() {
        return {
            hideMenu: false,
            hide: false,
            showNotification: {},
            notificationMessage: '',
        };
    },
    methods: {
        showMessage(event) {
            this.notificationMessage = event.detail.message;
            if (event.detail.type === 'success') {
                this.showNotification.success = true;
            } else if (event.detail.type === 'info') {
                this.showNotification.info = true;
            } else {
                this.showNotification.error = true;
            }

            setTimeout(() => {
                this.showNotification = {};
                this.notificationMessage = '';
            }, 8000);
        },
    },
};
</script>
